import React, { useEffect } from "react";
import { Card, CardBody } from "reactstrap";

import { Actions, State } from "../types";

type Props = Readonly<{
  clearActiveJob: Actions["clearActiveJob"];
  jobState: State["job"];
  review: boolean;
  sidebarVisibile: boolean;
}>;

export const SelectJob = ({ clearActiveJob, jobState, review, sidebarVisibile }: Props) => {
  useEffect(clearActiveJob, [jobState]);
  let message = "Select a job from the menu in the top-left.";
  if (review) {
    message = "Please close this window.";
  } else if (sidebarVisibile) {
    message = "Select a job.";
  }
  return (
    <div className="d-flex align-items-center h-100 justify-content-center w-100">
      <Card color="secondary">
        <CardBody className="p-4">
          <h1 className="display1 m-0 text-white">{message}</h1>
        </CardBody>
      </Card>
    </div>
  );
};
SelectJob.displayName = "SelectJob";
